import {
	useFlow,
	useFlowScreens,
	useFlowsMetadata,
	useUpdateFlow
} from '@api/flows';
import FlowBuilder from '@components/Flows/FlowBuilder/FlowBuilder';
import { APP_ROUTES } from 'constants/routes';
import { useNavigate } from 'hooks';
import React, { FC } from 'react';
import { useParams } from 'react-router-dom';
import { ReactFlowProvider } from 'reactflow';

const FlowBuilderPage: FC = () => {
	const { flowId } = useParams();
	const navigate = useNavigate();
	const { data: flow, isLoading: isFlowLoading } = useFlow(flowId);
	const { data: flowsMetadata, isLoading: isActionsLoading } =
		useFlowsMetadata();

	const { data: screens, isLoading: isScreensLoading } = useFlowScreens(
		flowId || ''
	);
	const isLoading = isFlowLoading || isActionsLoading || isScreensLoading;
	const { mutateAsync } = useUpdateFlow();

	if (!flow && !isLoading) {
		navigate(APP_ROUTES.flows);
	}

	return (
		<ReactFlowProvider>
			<FlowBuilder
				isLoading={isLoading}
				flow={flow}
				screens={screens}
				metadata={flowsMetadata}
				onUpdate={mutateAsync}
			/>
		</ReactFlowProvider>
	);
};

export default FlowBuilderPage;
